<template>
  <div>
    <van-action-sheet
        v-model="showChooseMakePoster"
        style="border-bottom: 1px solid #eeeeee"
    >
      <div style="margin-bottom: 5px; text-align: center; font-size: 17px; ">

        <div style="padding: 10px 0px;" @click="showMiniAppSharePop(skuInfo.skuId)">
          <div>商品海报-小程序</div>
          <div style="font-size: 10px; color: #aaaaaa;">扫码进入小程序购买商品，新粉丝需先注册</div>
        </div>
        <div style="height: 1px; background-color: #eeeeee"></div>
        <div style="padding: 10px 0px;" @click="showNormalSharePop">
          <div>商品海报</div>
          <div style="font-size: 10px; color: #aaaaaa;">扫码可直接购买商品</div>
        </div>
        <div style="height: 6px; background-color: #eeeeee"></div>
        <div style="padding: 15px 0px;" @click="showChooseMakePoster = false">取消</div>
      </div>

    </van-action-sheet>

    <!--        <Wp_share_poster v-if="$common.hasWxUserInfo_mini() || $common.hasWxUserInfo_public()"-->
    <Wp_share_poster
        :share-url="newLink"
        :activeShow="show_share_pop"
        :use-to="shareUseTo"
        :use-jd-logo="true"
        correct-level="H"
    >
      <div style="text-align: left">

        <Wp_image v-if="posterImg" :url="posterImg" width="100%"/>
        <Wp_image v-else-if="share_img_url" :url="share_img_url" width="100%"/>

        <div style="font-size: 15px; font-weight: bold; padding: 0px 7px">
                    <span>
                        <van-tag type="danger" style="font-size: 13px; padding: 0px 6px"
                                 v-if="skuInfo.owner==='g'">京东自营</van-tag>
                        <van-tag type="danger" style="font-size: 13px; padding: 0px 6px" v-else>京东</van-tag>
                    </span>
          {{ skuInfo.skuName }}
        </div>
        <div style="text-align: right; margin-right: 7px; color: #666666">
          评论数 {{ skuInfo.comments }}&nbsp;&nbsp;
          好评率 {{ skuInfo.goodCommentsShare }}%
        </div>
      </div>
      <div v-if="$common.hasWxUserInfo_mini()" slot="text"
           style="min-height: 80px; font-weight: normal; margin-top: -10px">

        <div style="color:red; font-size: 15px; margin-left: 7px;">
          <div v-if="couponData && couponData.discount && skuInfo.priceInfo.lowestCouponPrice">
            <div>
              内购价 ¥
              <span
                  style="font-size: 22px; font-weight: bold">{{
                  (skuInfo.priceInfo.lowestCouponPrice-giftPrice).toFixed(2)
                }}</span>
            </div>
            <div style="color: #999999; margin-top: -5px">
              京东价 <span style="text-decoration:line-through;">¥ {{ skuInfo.priceInfo.lowestPrice }}</span>
              <span style="color: #FF0000; ">&nbsp;&nbsp;&nbsp;优惠券  ¥ <span
                  style="font-size: 18px">{{ couponData.discount }}</span></span>
              <JdGiftBar :gift-data="giftData" size="xxl"/>
            </div>
          </div>
          <div v-else>
            京东价 ¥ <span style="font-size: 22px; font-weight: bold">{{ skuInfo.priceInfo.lowestPrice }}</span>
            <div>&nbsp;</div>
          </div>
          <div v-if="$common.hasWxUserInfo_mini()">
            <van-cell style="padding: 0px; margin: 0px" :border="false">
              <!--                            <van-image slot="icon" :src="$store.state.wx_img" round style="width: 45px;" fit="contain"/>-->
              <img slot="icon" :src="$common.gloabl_wx_mini_user_info.headimgurl" width="45px" height="45px"
                   style="border-radius: 50%;">
              <div slot="title" style="margin-left: 10px; font-size: 13px; ">
                <div>
                  <span style="font-size: 16px;">好友{{ $common.gloabl_wx_mini_user_info.nickname }}</span>
                </div>
                <div style="margin-top: -3px">
                  <span style="font-size: 13px; color: #999999">推荐您享受京东购物内购优惠</span>
                </div>
              </div>
            </van-cell>
          </div>
          <!--                    <div v-else-if="$common.hasWxUserInfo_public()">-->
          <!--                        <van-cell style="padding: 0px; margin: 0px" :border="false">-->
          <!--                            &lt;!&ndash;                            <van-image slot="icon" :src="$store.state.wx_img" round style="width: 45px;" fit="contain"/>&ndash;&gt;-->
          <!--                            <img slot="icon" :src="$store.state.wx_img" width="45px" height="45px" style="border-radius: 50%;">-->
          <!--                            <div slot="title" style="margin-left: 10px; font-size: 13px; ">-->
          <!--                                <div>-->
          <!--                                    <span style="font-size: 16px;">好友{{$store.state.wx_name}}</span>-->
          <!--                                </div>-->
          <!--                                <div style="margin-top: -3px">-->
          <!--                                    <span style="font-size: 13px; color: #999999">推荐您享受京东购物内购优惠</span>-->
          <!--                                </div>-->
          <!--                            </div>-->
          <!--                        </van-cell>-->
          <!--                    </div>-->

          <div style=" color:red; font-size: 15px; text-align: left">
            万品京选
            <span style="font-size: 12px; color: #999999">京东社交电商战略合作伙伴</span>
          </div>

        </div>
      </div>
      <div v-else slot="text" style="min-height: 80px; font-weight: normal; margin-top: 3px">

        <div style="color:red; font-size: 15px; margin-left: 7px;">
          <div v-if="couponData && couponData.discount && skuInfo.priceInfo.lowestCouponPrice">
            <div>
              内购价 ¥
              <span
                  style="font-size: 22px; font-weight: bold">{{
                  (skuInfo.priceInfo.lowestCouponPrice-giftPrice).toFixed(2)
                }}</span>
            </div>
            <div style="color: #999999">
              京东价 <span style="text-decoration:line-through;">¥ {{ skuInfo.priceInfo.lowestPrice }}</span>

              <span style="color: #FF0000; ">&nbsp;&nbsp;&nbsp;优惠券  ¥ <span
                  style="font-size: 18px">{{ couponData.discount }}</span></span>
              <JdGiftBar :gift-data="giftData" size="xxl"/>
            </div>
          </div>
          <div v-else>
            京东价 ¥ <span style="font-size: 22px; font-weight: bold">{{ skuInfo.priceInfo.lowestPrice }}</span>
            <div>&nbsp;</div>
          </div>
          <div style="margin-top: 5px; color:red; font-size: 15px; text-align: left">
            万品京选
            <span style="font-size: 12px; color: #999999">京东社交电商战略合作伙伴</span>
          </div>

        </div>
      </div>

      <div slot="qr_bottom" :style="{marginRight: $common.hasWxUserInfo_mini() ? '15px' : '7px'}">
        <div style="color: #888888; font-size: 11px; text-align: right">长按识别二维码</div>
      </div>

      <!--            <div slot="qr_bottom">-->
      <!--                <div style="color: #888888; font-size: 11px; margin-right: 9px; text-align: right">长按识别二维码</div>-->
      <!--            </div>-->
    </Wp_share_poster>
    <!--        <Wp_share_poster v-else :share-url="newLink"-->
    <!--                         :activeShow="show_share_pop"-->
    <!--                         :use-to="shareUseTo"-->
    <!--                         :use-jd-logo="true"-->
    <!--                         correct-level="H"-->
    <!--        >-->
    <!--            <div style="text-align: left">-->

    <!--                <Wp_image v-if="posterImg" :url="posterImg" width="100%"/>-->
    <!--                <Wp_image v-else-if="share_img_url" :url="share_img_url" width="100%"/>-->

    <!--                <div style="font-size: 15px; font-weight: bold; padding: 0px 5px">-->
    <!--                    <span>-->
    <!--                        <van-tag type="danger" style="font-size: 13px; padding: 0px 6px" v-if="skuInfo.owner==='g'">京东自营</van-tag>-->
    <!--                        <van-tag type="danger" style="font-size: 13px; padding: 0px 6px" v-else>京东</van-tag>-->
    <!--                    </span>-->
    <!--                    {{skuInfo.skuName}}-->
    <!--                </div>-->
    <!--                <div style="text-align: right; margin-right: 8px; color: #666666">-->
    <!--                    评论数 {{skuInfo.comments}}&nbsp;&nbsp;-->
    <!--                    好评率 {{skuInfo.goodCommentsShare}}%-->
    <!--                </div>-->

    <!--            </div>-->
    <!--            <div slot="text" style="min-height: 80px; font-weight: normal; margin-top: 3px">-->

    <!--                <div style="color:red; font-size: 15px; margin-left: 5px;">-->
    <!--                    <div v-if="couponData && couponData.discount">-->
    <!--                        <div>-->
    <!--                            内购价 ¥-->
    <!--                            <span style="font-size: 22px; font-weight: bold">{{(skuInfo.priceInfo.lowestPrice - couponData.discount).toFixed(2)
    }}</span>-->
    <!--                        </div>-->
    <!--                        <div style="color: #999999">-->
    <!--                            京东价 <span style="text-decoration:line-through;">¥ {{skuInfo.priceInfo.lowestPrice
    }}</span>-->

    <!--                            <span style="color: #FF0000; ">&nbsp;&nbsp;&nbsp;优惠券  ¥ <span style="font-size: 18px">{{couponData.discount
    }}</span></span>-->
    <!--                        </div>-->
    <!--                    </div>-->
    <!--                    <div v-else>-->
    <!--                        京东价 ¥ <span style="font-size: 22px; font-weight: bold">{{skuInfo.priceInfo.lowestPrice
    }}</span>-->
    <!--                        <div>&nbsp;</div>-->
    <!--                    </div>-->
    <!--&lt;!&ndash;                    <div v-if="$common.gloabl_wx_mini_user_info && $common.gloabl_wx_mini_user_info.nickname && $common.gloabl_wx_mini_user_info.headimgurl"&ndash;&gt;-->
    <!--&lt;!&ndash;                         style="margin-top: 10px;">&ndash;&gt;-->
    <!--&lt;!&ndash;                        <van-cell style="padding: 0px; margin: 0px" :border="false">&ndash;&gt;-->
    <!--&lt;!&ndash;                            &lt;!&ndash;                            <van-image slot="icon" :src="$store.state.wx_img" round style="width: 45px;" fit="contain"/>&ndash;&gt;&ndash;&gt;-->
    <!--&lt;!&ndash;                            <img slot="icon" :src="$common.gloabl_wx_mini_user_info.headimgurl" width="40px" height="40px" style="border-radius: 50%;">&ndash;&gt;-->
    <!--&lt;!&ndash;                            <div slot="title" style="margin-left: 10px; font-size: 13px; ">&ndash;&gt;-->
    <!--&lt;!&ndash;                                <div>&ndash;&gt;-->
    <!--&lt;!&ndash;                                    <span style="font-size: 18px;">好友{{$common.gloabl_wx_mini_user_info.nickname
    }}</span>&ndash;&gt;-->
    <!--&lt;!&ndash;                                </div>&ndash;&gt;-->
    <!--&lt;!&ndash;                                <div>&ndash;&gt;-->
    <!--&lt;!&ndash;                                    <span style="font-size: 12px; color: #999999">推荐您享受京东购物内购优惠</span>&ndash;&gt;-->
    <!--&lt;!&ndash;                                </div>&ndash;&gt;-->
    <!--&lt;!&ndash;                            </div>&ndash;&gt;-->

    <!--&lt;!&ndash;                        </van-cell>&ndash;&gt;-->
    <!--&lt;!&ndash;                    </div>&ndash;&gt;-->

    <!--                    <div style="margin-top: 5px; color:red; font-size: 15px; text-align: left">-->
    <!--                        万品京选-->
    <!--                        <span style="font-size: 12px; color: #999999">京东社交电商战略合作伙伴</span>-->
    <!--                    </div>-->

    <!--                </div>-->
    <!--            </div>-->
    <!--            <div slot="qr_bottom">-->
    <!--                <div style="color: #888888; font-size: 11px; margin-right: 9px; text-align: right">长按识别二维码</div>-->
    <!--            </div>-->
    <!--        </Wp_share_poster>-->
    <van-popup v-model="showLoading">

      <van-loading type="spinner" color="#1989fa" vertical
                   style="padding: 30px;">
        <div slot="default" style="text-align: center">海报制作中<br>&nbsp;请稍后...</div>
      </van-loading>

    </van-popup>
  </div>
</template>

<script>
import Wp_share_poster from './Wp_share_poster'
import Wp_image from './Wp_image'
import { Toast } from 'vant'
import JdGiftBar from './JdGiftBar'

export default {
  name: 'Wp_jd_skuinfo_poster',
  components: { JdGiftBar, Wp_image, Wp_share_poster },
  props: {
    skuInfo: { type: Object, default: null },
    couponData: { type: Object, default: null },
    giftData: { type: Object, default: null },
    posterImg: { type: String, default: '' }
  },

  data () {
    return {
      newLink: '',
      share_img_url: '',
      show_share_pop: '',
      showChooseMakePoster: false,
      shareUseTo: '',
      showLoading: false,
      giftPrice: 0,
      giftText: '',
    }
  },

  watch: {
    giftData: {
      handler (nV, oV) {
        if (this.giftData && this.giftData.denomination) {
          this.giftPrice = this.giftData.denomination
          this.giftText = '+礼金' + this.giftPrice + '元'
        }
      },
      immediate: true,
      deep: true
    }
  },

  mounted () {
    this.share_img_url = this.skuInfo.imageInfo.imageList[0].url
  },

  methods: {
    showSharePop () {
      this.showChooseMakePoster = true

      if (!this.$common.gloabl_wx_mini_user_info || !this.$common.gloabl_wx_mini_user_info.u_code) {
        this.showNormalSharePop()
      }

      // this.$wx.miniProgram.getEnv(res => {
      //     if (!res.miniprogram) {
      //         this.showNormalSharePop();
      //     }
      // });

      // this.showNormalSharePop();
    },

    /**
     * 制作普通海报
     */
    showNormalSharePop () {
      this.showChooseMakePoster = false
      this.shareUseTo = ''
      this.showLoading = true
      this.makeLinks(() => {
        this.showLoading = false
        let timestamp = '_' + Date.parse(new Date())
        this.show_share_pop = timestamp
      })
      // this.$log(JSON.stringify(this.skuInfo))
    },

    /**
     * 制作小程序海报
     * @param skuId
     */
    showMiniAppSharePop (skuId) {
      this.showChooseMakePoster = false
      this.shareUseTo = 'mini_app'
      this.showLoading = true
      this.getQrcodeUrl(skuId, qr_img_url => {
        this.newLink = qr_img_url
        let timestamp = '_' + Date.parse(new Date())
        this.show_share_pop = timestamp
      })
    },

    getQrcodeUrl (skuId, fn) {
      if (this.$common.gloabl_wx_mini_user_info) {
        let u_code = this.$common.gloabl_wx_mini_user_info.u_code

        let params = {
          app_id: this.$common.wx_app_id,
          app_secret: this.$common.wx_app_secret,
          scene: u_code + ';' + skuId,
          width: 300
        }
        this.$getWxAppQrcode(params, response => {
          this.$log(response)
          if (response && response.data) {
            this.showLoading = false
            let qr_img_url = response.data
            if (qr_img_url) {
              if (fn) {
                fn(qr_img_url)
              }
            }
          } else {
            this.showLoading = false
            this.$dialog.alert({
              message: '邀请海报制作失败，请重试'
            })
          }
        })
      }
    },

    makeLinks (fn) {
      let _skuId = this.skuInfo.skuId
      if (_skuId) {
        let _materialId = 'https://wqitem.jd.com/item/view?sku=' + _skuId
        let _couponUrl = ''
        if (this.couponData && this.couponData.discount && typeof (this.couponData.discount) !== 'undefined' && this.skuInfo.priceInfo.lowestCouponPrice) {
          _couponUrl = this.couponData.link
        }
        let _positionId = this.$common.getPid()
        // let _positionId = '1825325610';
        let _data = {
          app_key: this.$common.getAppKeyInfo('70637').app_key,
          app_secret: this.$common.getAppKeyInfo('70637').app_secret,
          materialId: _materialId,
          subUnionId: '',
          positionId: _positionId, //推广位ID
          // pid: _pid,
          couponUrl: _couponUrl,
          chainType: 2,
        }

        //添加礼金代码
        if (this.giftData && this.giftData.giftCouponKey) {
          _data['giftCouponKey'] = this.giftData.giftCouponKey
        }

        this.$getUnionLink(_data, response => {
          let code = response.code
          // let message = response.message;
          if (code === 200) {
            let shortURL = response.data.shortURL
            this.newLink = shortURL
            if (fn && typeof fn === 'function') {
              fn(shortURL)
            } else {
              this.getLinkContent(shortURL)
              //使用setTimeout避免ActionSheet使用了Swipe弹出时，会先跟着半透明蒙板变暗，然后再完全展现
              setTimeout(() => {
                this.imageList = this.skuInfo.imageInfo.imageList
              })
              //打开复制文案弹窗
              this.showLink = true
            }

          } else {
            // Dialog.alert({
            //     message: "添加失败，商品活动已过期"
            // });
            this.showLoading = false
            Toast({
              duration: 1000,
              message: '制作失败\n商品活动已过期'
            })
          }
          // else if (code === 2001917) {
          //     this.$dialog.alert({
          //         message: response.message
          //     });
          // }
        })
      }

    },
  }
}
</script>

<style scoped>

</style>